import { ToastProvider } from '@zenterprise-inc/ui';
import { ReactNode } from 'react';

import HomeFooter from '@/components/layout/HomeFooter';
import HomeHeader from '@/components/layout/HomeHeader';

const HomeLayout = ({ children }: { children: ReactNode }) => {
  return (
    <ToastProvider>
      <HomeHeader />
      <main>{children}</main>
      <HomeFooter />
    </ToastProvider>
  );
};

export default HomeLayout;
